import { Box, Typography } from '@mui/material';
import * as React from 'react';

import muiStyles from './styles';
import { AttributeTagProps } from './types';

export default function AttributeTag(props: AttributeTagProps) {
    const {
        id,
        className,
        attribute,
        styleBox
    } = props;

    const classes = muiStyles(props);

    return (
        <Typography
            className={`${classes.root} ${className}`}
            data-testid='attribute-tag-container'
            id={id}
            variant='h4'
        >
            <Box
                className={`${styleBox} ${classes.text}`}
                data-testid='attribute-tag-value'
            >
                {attribute}
            </Box>
        </Typography>
    );
}